import React, { useState } from 'react';
import { Card, CardBody, Collapse } from 'reactstrap';

const EmailListSettings = ({ emailListExists, mgListAddress, settings }) => {
    const [open, setOpen] = useState(true);

    if (!emailListExists) return null;

    return (
        <Card>
            <h5
                className="card-header cursorPointer"
                onClick={() => setOpen(!open)}
            >
                <span className="email-list-settings-title">
                    <i className="fa fa-wrench mr-2" aria-hidden="true"></i>
                    Email List Settings
                </span>
                <span className="ml-auto">
                    <i
                        className={`pull-right float-right fas arrow-icon fa-chevron-${open ? 'down' : 'up'} email-list-settings-chevron`}
                    ></i>
                </span>
            </h5>
            <Collapse className="memberCardCollapse" isOpen={open}>
                <CardBody>
                    <div className="email-list-settings-item">
                        <label>Email List Address:</label> {mgListAddress}
                    </div>
                    {settings && (
                        <>
                            <div className="email-list-settings-item">
                                <label>Reply Preference:</label> {settings.replyPreference}
                            </div>
                            <div className="email-list-settings-item">
                                <label>Copy to Sender:</label> {settings.copyToSender ? 'Yes' : 'No'}
                            </div>
                            <div className="email-list-settings-item">
                                <label>Allowed to send to List:</label> {settings.privilegeLevel}
                            </div>
                        </>
                    )}
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default EmailListSettings; 